import { newUtil } from '@meitu/saas-editor-core/es/utils/dom-to-image';

/**
 * ObjectURL 帮助类
 */
export const objectURLHelper = {
    /** 销毁 object url */
    revoke(url = '') {
        if (objectURLHelper.isBlob(url)) {
            try {
                URL.revokeObjectURL(url);
            } catch (e) {
                console.log(e);
            }
        }
    },
    /** 创建 object url */
    async create(canvas: HTMLCanvasElement) {
        const blob = await newUtil().canvasToBlob(canvas);
        return URL.createObjectURL(blob);
    },

    isHttp(url = '') {
        return url.startsWith('http');
    },

    isBlob(url = '') {
        return url.startsWith('blob:');
    },
};
